import { first } from 'lodash'
import Header from '../components/Header'
import CustomersLoveUs from '../components/HomePage/CustomersLoveUs'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import HeroBanner from '../components/Reviews/HeroBanner'
import Footer from '../components/Footer'
import { GeneralAPI } from '../apis/GeneralAPI'
import SectionHeading from '../components/HomePage/SectionHeading'
import CaseStudies from '../components/Reviews/CaseStudies'

function Reviews({ reviews, data }) {
    const videoReviews = reviews.filter((review) => review.type === 'Video')

    const customLoveUsSectionHeading = (
        <SectionHeading>
            But don&apos;t take our word for it, <br />
            hear it from them
        </SectionHeading>
    )

    return (
        <LandingPageWrapper>
            <Header meta={data?.yoast_head} />
            <div className="bg-light-yellow-gradient space-y-10 md:space-y-20 xl:px-0 rounded-8xl py-20 rounded-t-none -mt-10 md:-mt-20">
                <HeroBanner />
                <CustomersLoveUs
                    allReviews={reviews}
                    showTestimonials={true}
                    sectionHeading={customLoveUsSectionHeading}
                    hasSectionHeading={true}
                    reviews={videoReviews}
                />
            </div>
            <CaseStudies />
            <Footer />
        </LandingPageWrapper>
    )
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps() {
    // const data = { } //await GeneralAPI.getFrontPage()
    const page = await GeneralAPI.getPageBySlug('/reviews')
    const data = page ? page[0] : {}

    const { acf: reviewsACF } = first(await GeneralAPI.getPageBySlug('reviews'))
    const reviews = reviewsACF?.reviews?.length > 0 ? reviewsACF.reviews : []

    return {
        props: {
            reviews,
            data,
        },
        revalidate: 10, // In seconds
    }
}

export default Reviews
